import { render, staticRenderFns } from "./renew-subscriptions-modal.vue?vue&type=template&id=d56b31d0&scoped=true&"
import script from "./renew-subscriptions-modal.vue?vue&type=script&lang=ts&"
export * from "./renew-subscriptions-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56b31d0",
  null
  
)

export default component.exports